import { Link } from 'react-router-dom';
import { DemoZoomCarousel } from '../components/DemoZoomCarousel';
import { LandingMarketing } from '../components/marketing/LandingMarketing';
import { useAuth } from '../hooks/useAuth';
import { t } from '../hooks/useT';

export function LandingPage() {
  const { user, loading } = useAuth();
  const isConnected = !loading && !!user;
  const showMarketing = !loading && !user;

  return (
    <main className={`page landing${isConnected ? ' landing--connected' : ''}${showMarketing ? ' landing--marketing' : ''}`}>
      <header className="hero">
        <h1 className="logo-mark">Dezoom</h1>
        <p className="tagline">{t('landing.tagline')}</p>

        <DemoZoomCarousel />

        {!loading && !user && (
          <div className="cta-row cta-row-single">
            <Link to="/play" className="btn primary">{t('landing.cta')}</Link>
          </div>
        )}

        {!loading && user ? (
          <div className="home-auth-card home-auth-welcome">
            <p className="home-auth-greeting">
              {t('landing.welcome')} {user.displayName}
            </p>
            <div className="home-auth-actions">
              <Link to="/play" className="btn primary block">{t('landing.cta')}</Link>
              <Link to="/archives" className="btn secondary block">{t('archives.title')}</Link>
              <Link to="/profile" className="btn secondary block">{t('landing.profile')}</Link>
            </div>
          </div>
        ) : (
          <div className="home-auth-card">
            <h2 className="home-auth-title">{t('landing.authTitle')}</h2>
            <ul className="home-auth-perks">
              <li>{t('landing.authPerk1')}</li>
              <li>{t('landing.authPerk2')}</li>
              <li>{t('landing.authPerk4')}</li>
              <li>{t('landing.authPerk3')}</li>
            </ul>
            <Link to="/login" className="btn secondary block">{t('landing.login')}</Link>
            <p className="home-auth-note">{t('landing.authNote')}</p>
          </div>
        )}
      </header>

      {showMarketing && <LandingMarketing />}
    </main>
  );
}
